module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_8.325fe167.png";